var _defs, _rect, _polygon, _polygon2, _polygon3, _polygon4, _path, _polygon5, _path2, _path3, _path4, _polygon6, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _polyline, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _polyline2, _path5, _polygon7, _line23, _line24, _polyline3, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _path6, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _path7, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _polygon8, _line83, _line84, _line85, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _line100, _line101, _line102, _line103, _line104, _line105, _line106, _line107, _polygon9, _polygon10, _path8, _path9, _path10, _polyline4, _line108, _line109, _line110;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituationReparationBaignoire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3001.65 3000.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_57);}.cls-2{fill:#99a1ce;}.cls-3{fill:#3e487f;}.cls-4{fill:#bcbcbc;}.cls-5{fill:#dbdbdb;}.cls-6{opacity:0.47;fill:url(#D\xE9grad\xE9_sans_nom_20);}.cls-7{fill:#fff;}.cls-8{opacity:0.5;fill:url(#D\xE9grad\xE9_sans_nom_30);}.cls-9{opacity:0.28;fill:url(#D\xE9grad\xE9_sans_nom_36);}.cls-10,.cls-13{fill:none;stroke-miterlimit:10;stroke-width:10px;}.cls-10{stroke:#ededed;}.cls-11{fill:#ededed;}.cls-12{fill:#c9c9c9;}.cls-13{stroke:#c9c9c9;}.cls-14{fill:#3a3632;}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_43);}.cls-16{fill:#191614;}.cls-17{fill:#5b5b5b;}.cls-18{fill:#444;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_57",
    x1: 1487.67,
    y1: 3052.26,
    x2: 1513.33,
    y2: 2317.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ababab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2c2c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_20",
    x1: 753.49,
    y1: 1514.63,
    x2: 1241.76,
    y2: 1336.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30",
    x1: 1820.95,
    y1: 1493.83,
    x2: 1822.67,
    y2: 1444.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_36",
    x1: 2094.66,
    y1: 1295.47,
    x2: 2096.36,
    y2: 1246.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43",
    x1: 778,
    y1: 2423.3,
    x2: 796.89,
    y2: 1882.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "r\xE9paration baignoire") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 2369.3,
    width: 3001,
    height: 631
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1 2435.3 456 2462.3 390 0.3 1 0.3 1 2435.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "520 2412.3 500 1392.31 643 1450.31 3001 1535.31 3001 2625.3 520 2412.3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1143 1195.31 1143 0.3 3001 0.3 3001 1245.31 1143 1195.31"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "456 2462.3 520 2412.3 500 1392.31 643 1450.31 1243 1246.3 3001 1278.31 3001 1245.31 1143 1195.31 1143 0.3 390 0.3 456 2462.3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M642,1445",
    transform: "translate(1 0.3)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "643 1450.31 1243 1245.31 3001 1278.31 3001 1535.31 643 1450.31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M720.24,1423.27Q833.61,1393,947,1423l315,10s-29-126-39-147-24.6-26.1-24.6-26.1Z",
    transform: "translate(1 0.3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1364.68,1432l-7.52-67.94c-.41-6.43,8.78-8,10.54-1.81l16.35,67.94a5.38,5.38,0,0,1-5.17,6.85h-8.83A5.38,5.38,0,0,1,1364.68,1432Z",
    transform: "translate(1 0.3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M957.24,1423.27,3000,1488v47L642,1450l78-27C793,1405.26,872.63,1407,957.24,1423.27Z",
    transform: "translate(1 0.3)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1188.76 1263.84 1243 1245.31 3001 1278.31 3001.25 1306.96 1188.76 1263.84"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 347,
    y1: 2234.3,
    x2: 336.75,
    y2: 1975.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 126.69,
    y1: 2442.78,
    x2: 126.75,
    y2: 2232.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 24,
    y1: 2220.3,
    x2: 16,
    y2: 1956.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 0.49,
    y1: 2220.66,
    x2: 450.25,
    y2: 2247.78
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 0.49,
    y1: 1955.73,
    x2: 443.04,
    y2: 1978.99
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2.44,
    y1: 1686.91,
    x2: 435.58,
    y2: 1700.53
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2.44,
    y1: 1410.65,
    x2: 428.06,
    y2: 1419.96
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 420.64,
    y1: 1143.43,
    x2: 2.44,
    y2: 1143.43
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2.44,
    y1: 864.87,
    x2: 413.18,
    y2: 864.87
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2.44,
    y1: 586.31,
    x2: 405.76,
    y2: 588.19
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1143,
    y1: 401.3,
    x2: 3001,
    y2: 366.3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1,
    y1: 303.86,
    x2: 395.93,
    y2: 292.17
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "1 0.3 1 20.57 390.14 5.39 390 0.3 1 10.3"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 115,
    y1: 1961.3,
    x2: 107,
    y2: 1693.3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 326,
    y1: 1697.3,
    x2: 318,
    y2: 1420.3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 99,
    y1: 1412.3,
    x2: 91,
    y2: 1143.3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 307,
    y1: 1143.3,
    x2: 299,
    y2: 865.3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 74,
    y1: 866.3,
    x2: 66,
    y2: 588.3
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 292,
    y1: 584.3,
    x2: 284,
    y2: 292.3
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 47,
    y1: 300.3,
    x2: 39,
    y2: 14.3
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 505,
    y1: 1666.3,
    x2: 3001.25,
    y2: 1781.47
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 510.7,
    y1: 1938.2,
    x2: 3001.25,
    y2: 2088.3
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 515.79,
    y1: 2197.54,
    x2: 3001.25,
    y2: 2395.07
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "516 2412.3 1210.48 2471.83 3001 2625.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M695,1868",
    transform: "translate(1 0.3)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "716 2429.3 696 1868.31 1211 1901.31 1210 2472.3 716 2429.3"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 696,
    y1: 1675.2,
    x2: 696,
    y2: 1868.3
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 868.73,
    y1: 1683.17,
    x2: 869,
    y2: 1879.3
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "763.23 1678.3 759.28 1454.5 643 1454.31 500 1392.31"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1095.34,
    y1: 1466.61,
    x2: 1095,
    y2: 1687.3
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1205,
    y1: 1700.53,
    x2: 1211,
    y2: 1901.3
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1437.84,
    y1: 1709.4,
    x2: 1437.84,
    y2: 1478.96
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1789.16,
    y1: 1491.62,
    x2: 1789.16,
    y2: 1725.6
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1912.39,
    y1: 1731.28,
    x2: 1912.39,
    y2: 2022.68
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2164.9,
    y1: 1505.17,
    x2: 2164.9,
    y2: 1742.92
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2543.36,
    y1: 1518.81,
    x2: 2543.36,
    y2: 1760.37
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2283.72,
    y1: 1748.4,
    x2: 2283.72,
    y2: 2045.06
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2669.47,
    y1: 2068.31,
    x2: 2669.47,
    y2: 1766.18
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2543.36,
    y1: 2060.71,
    x2: 2543.36,
    y2: 2358.68
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2932.33,
    y1: 2389.59,
    x2: 2932.33,
    y2: 2088.3
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2677.16,
    y1: 2369.31,
    x2: 2677.16,
    y2: 2597.55
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2283.72,
    y1: 2563.82,
    x2: 2283.72,
    y2: 2338.04
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2154.39,
    y1: 2327.76,
    x2: 2154.39,
    y2: 2037.27
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1920.23,
    y1: 2309.15,
    x2: 1920.23,
    y2: 2532.67
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1789.16,
    y1: 2298.74,
    x2: 1789.16,
    y2: 2015.25
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1562.13,
    y1: 2280.7,
    x2: 1562.13,
    y2: 2501.77
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1437.84,
    y1: 2270.82,
    x2: 1431.9,
    y2: 1993.72
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1553.6,
    y1: 1714.74,
    x2: 1553.6,
    y2: 2001.06
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1143,
    y1: 1195.3,
    x2: 1143,
    y2: 0.3
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 3001.25,
    y1: 1035.29,
    x2: 1143,
    y2: 1018.27
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1142,799.11s1846-.11,1858.25,0",
    transform: "translate(1 0.3)"
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 3001.25,
    y1: 569.3,
    x2: 1143,
    y2: 586.31
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1302,
    y1: 1018.3,
    x2: 1296.4,
    y2: 799.42
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1383.65,
    y1: 584.11,
    x2: 1388.42,
    y2: 799.37
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1657.28,
    y1: 584.11,
    x2: 1657.28,
    y2: 799.37
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1937,
    y1: 578.3,
    x2: 1944.07,
    y2: 799.42
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2224.91,
    y1: 576.41,
    x2: 2229.67,
    y2: 799.42
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2519,
    y1: 569.3,
    x2: 2524.83,
    y2: 799.42
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2829.54,
    y1: 570.88,
    x2: 2829.54,
    y2: 799.37
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2725.58,
    y1: 799.42,
    x2: 2725.58,
    y2: 1035.29
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2829.54,
    y1: 1033.72,
    x2: 2829.54,
    y2: 1240.69
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2529.6,
    y1: 1030.97,
    x2: 2529.6,
    y2: 1232.62
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2238.05,
    y1: 1028.3,
    x2: 2238.05,
    y2: 1224.77
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1950.04,
    y1: 1025.66,
    x2: 1950.04,
    y2: 1217.02
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1672.82,
    y1: 1023.12,
    x2: 1672.82,
    y2: 1209.56
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1401.57,
    y1: 1020.64,
    x2: 1401.57,
    y2: 1202.26
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1566.47,
    y1: 799.42,
    x2: 1575,
    y2: 1018.3
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1844.89,
    y1: 799.37,
    x2: 1845,
    y2: 1018.3
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2131.68,
    y1: 799.42,
    x2: 2132,
    y2: 1023.3
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2426.84,
    y1: 799.42,
    x2: 2427,
    y2: 1028.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3000,131c-12.57.24-1858,50-1858,50",
    transform: "translate(1 0.3)"
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1377.23,
    y1: 395.53,
    x2: 1365.37,
    y2: 176.89
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1451,
    y1: 0.3,
    x2: 1459.74,
    y2: 174.2
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1731,
    y1: 0.3,
    x2: 1735.5,
    y2: 166.48
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2020,
    y1: 0.3,
    x2: 2029.64,
    y2: 158.3
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2315,
    y1: 0.3,
    x2: 2322.56,
    y2: 150.1
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2618,
    y1: 0.3,
    x2: 2625.28,
    y2: 141.63
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2934,
    y1: 0.3,
    x2: 2937.8,
    y2: 132.83
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2831.18,
    y1: 135.87,
    x2: 2837.77,
    y2: 371.65
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2944.36,
    y1: 367.09,
    x2: 2950.15,
    y2: 573.99
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2636.66,
    y1: 372.96,
    x2: 2642.3,
    y2: 574.53
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2337.55,
    y1: 378.66,
    x2: 2343.05,
    y2: 575.05
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2042.09,
    y1: 384.28,
    x2: 2047.44,
    y2: 575.57
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1757.69,
    y1: 389.7,
    x2: 1762.91,
    y2: 576.07
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1479.42,
    y1: 395,
    x2: 1484.5,
    y2: 576.56
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1642.35,
    y1: 169.14,
    x2: 1657.23,
    y2: 387.69
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1927.91,
    y1: 161.1,
    x2: 1934.15,
    y2: 379.95
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2222.06,
    y1: 152.91,
    x2: 2228.65,
    y2: 376.71
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2524.78,
    y1: 144.44,
    x2: 2531.35,
    y2: 373.24
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "390 5.3 1138 186.31 1138 176.31 396.27 0.3 390 0.3 390 5.3"
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 397.81,
    y1: 291.63,
    x2: 1138,
    y2: 401.3
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 405.75,
    y1: 587.71,
    x2: 1138,
    y2: 586.3
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1138,
    y1: 799.3,
    x2: 413.22,
    y2: 866.3
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 413,
    y1: 1143.3,
    x2: 1143,
    y2: 1018.3
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1143,
    y1: 1195.3,
    x2: 428.07,
    y2: 1420.3
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 650.76,
    y1: 1350.22,
    x2: 643,
    y2: 1103.92
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 837.91,
    y1: 1291.32,
    x2: 837.91,
    y2: 1070.55
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1002.59,
    y1: 1042.35,
    x2: 1002.59,
    y2: 1239.49
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1047.05,
    y1: 807.71,
    x2: 1047.05,
    y2: 1034.73
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 892.2,
    y1: 1061.25,
    x2: 892.2,
    y2: 822.03
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 707.01,
    y1: 839.15,
    x2: 707.01,
    y2: 1092.96
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 488.03,
    y1: 859.39,
    x2: 500,
    y2: 1128.41
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 628.9,
    y1: 588.3,
    x2: 635.9,
    y2: 845.72
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 837.91,
    y1: 586.31,
    x2: 837.91,
    y2: 827.05
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 992,
    y1: 584.3,
    x2: 997,
    y2: 812.3
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 479,
    y1: 586.3,
    x2: 469,
    y2: 300.3
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 696.94,
    y1: 588.19,
    x2: 688.38,
    y2: 334.69
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 885.25,
    y1: 588.3,
    x2: 874.4,
    y2: 362.25
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1047,
    y1: 584.3,
    x2: 1039.72,
    y2: 387.69
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 955.92,
    y1: 374.33,
    x2: 949,
    y2: 136.3
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 778,
    y1: 346.3,
    x2: 768,
    y2: 93.3
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 584.41,
    y1: 319.28,
    x2: 575,
    y2: 45.3
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 666,
    y1: 66.3,
    x2: 664,
    y2: 0.3
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 854,
    y1: 112.3,
    x2: 848.66,
    y2: 0.3
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1053.71,
    y1: 156.3,
    x2: 1047.05,
    y2: 0.3
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "721 2421.3 709 1879.31 1198 1909.31 1205 2462.3 721 2421.3"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "721 2421.3 869 2337.3 847.01 1887.77 709 1879.31 721 2421.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M867.73,2331.57,967.94,2234l62.06-14c17.59-73.59,57.3-127.23,169.47-115.5L1199,1909l-353-22Z",
    transform: "translate(1 0.3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M963,2238.79c.18,9.08,59.91,7.89,59.73-1.19L1023,2109c13.22-1.27,16.4-7.09,15-15l161.27-6-1.27-60H1017c-34,0-53.37,32.74-54,68Z",
    transform: "translate(1 0.3)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1023,2109q-33.3-6-56.45-37.22l-2.34,10.57q29.38,26.88,58.79,33.65Z",
    transform: "translate(1 0.3)"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "1 2435.3 456 2462.3 520 2412.3"
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 435.58,
    y1: 1700.53,
    x2: 505.37,
    y2: 1666.32
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 443.04,
    y1: 1978.99,
    x2: 510.7,
    y2: 1938.2
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 450.25,
    y1: 2247.78,
    x2: 515.79,
    y2: 2197.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituationReparationBaignoire);
export default __webpack_public_path__ + "static/media/situation_reparation_baignoire.caf45f488cf17e4789af66cfebfad439.svg";
export { ForwardRef as ReactComponent };